import { getVipTypeByUser, isSingleVipByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { gdOssUrl } from "@/utils/imageUrl";
import classNames from "classnames";
import { useCallback, useMemo, useState } from "react";
import { Case, Switch } from "react-if";
import HBModal from "../../HBModal";
import PayResult from "../payResult";
import { useDialogContext, VipDialogContext } from "../shared/configContext";
import VipHeader from "../shared/header3";
import PublicTransfer from "../Transfer";
import styles from "./index.module.less";
import PkgDetail from "./pkgDetail";

/**
 * 增加次数弹框
 */
export default function IncreateTimesDialog({
  userRight,
  onOk,
  onCancel,
  onPaid,
  onFinish,
  onAborted,
  selectedPkg,
  ...props
}) {
  const user = useAppStore((s) => s.user);

  const context = useDialogContext(userRight);
  const { rightData, config } = context;

  const vipType = useMemo(() => {
    const type = getVipTypeByUser(user);

    // 体验会员、单品类会员特殊处理
    if (type === "experience" || isSingleVipByUser(user)) {
      return "personal";
    }

    // 大企业会员特殊处理
    if (type === "bigCompany") {
      return "company";
    }

    return type;
  }, [user]);

  // 步骤
  const [step, setStep] = useState("update");

  const [order, setOrder] = useState({});

  const onOrderDone = useCallback(
    (order) => {
      onPaid && onPaid(order);
      setOrder(order);
      setStep("payResult");
      // 重置会员到期提醒
      window.localStorage.removeItem(`ExpiredVipDialogKey_${user.user_id}`);
    },
    [onPaid, user.user_id]
  );

  const wrapStyle = useMemo(() => {
    return {
      width: 960,
      overflow: "hidden",
      backgroundImage: `url(${gdOssUrl(
        "https://st0.dancf.com/static/02/202202110238-4e8a.jpg",
        {
          width: 960,
        }
      )})`,
      backgroundSize: "cover",
    };
  }, []);

  // 取消弹框
  const onCancelWrap = useCallback(() => {
    if (step === "payResult") {
      onOk && onOk();
    } else {
      onCancel && onCancel(step);
    }
    // 不在前两步，调用 onFinish
    if (step !== "update") {
      onFinish && onFinish(order);
    } else {
      // 终止
      onAborted && onAborted(step);
    }
  }, [onCancel, step, onOk, onFinish, order, onAborted]);

  const [transferProps, setTransferProps] = useState({});
  const onTransfer = useCallback((transferProps) => {
    setStep("transfer");
    setTransferProps(transferProps);
  }, []);

  const onCancelTransfer = useCallback(() => {
    setStep("update");
  }, []);

  if (!rightData) {
    return null;
  }

  return (
    <VipDialogContext.Provider value={context}>
      <HBModal
        className={classNames(styles.dialog, {
          [styles.step1]: step === "update",
        })}
        {...props}
        width={960}
        footer={null}
        bodyStyle={{ padding: 0, overflowX: "auto" }}
        onCancel={onCancelWrap}
      >
        <div style={wrapStyle}>
          {["update", "pay", "transfer"].includes(step) && (
            <VipHeader
              userRight={rightData}
              user={user}
              onCancel={onCancelWrap}
            />
          )}

          <Switch>
            <Case condition={step === "update"}>
              <div key={step} style={{ marginTop: 90 }}>
                <PkgDetail
                  currentVipType={vipType}
                  defaultSelectedPkg={selectedPkg}
                  userRight={rightData}
                  conf={config}
                  onOrderDone={onOrderDone}
                  onCancel={onCancelWrap}
                  onTransfer={onTransfer}
                />
              </div>
            </Case>
            <Case condition={step === "transfer"}>
              <PublicTransfer
                {...transferProps}
                onCancelTransfer={onCancelTransfer}
              />
            </Case>
            <Case condition={step === "payResult"}>
              <PayResult
                key={step}
                title={"购买成功"}
                show={order?.trade_mode === "promotion"}
                order={order}
                style={{ height: 772 }}
              />
            </Case>
          </Switch>
        </div>
      </HBModal>
    </VipDialogContext.Provider>
  );
}
